module.exports = __webpack_public_path__ + "static/media/girl_writing.9e7dee84.webp";